/**
 * Tek z-index merdiveni. Onceden modallar 50 ile 99999999 arasinda dagilmis
 * degerler kullaniyordu; hata bildirimi bazen modalin ARKASINDA kaliyordu.
 */
export const Z_INDEX = {
  /** Tum modal/dialog overlay'leri. */
  modal: 999999,
  /** Toast katmani -- her modalin ustunde kalmali. */
  toast: 100000000,
} as const
